// The client-documents screen: every stored file that belongs to a client, nested
// client → retainer → job. Its own file rather than part of clients.js or documents.js
// — it is one screen with its own vocabulary, and documents.js is the OFFICE filing
// cabinet, which this page has nothing to do with.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const clientDocuments = {
  clientDocuments: {
    title: 'מסמכי לקוחות',
    // Says what the page IS and, just as importantly, what it is not: nothing is
    // uploaded, changed or deleted here. A read-only screen that looks like every
    // other list has to say so, or the first reaction to a missing file is to look
    // for an upload button that was never there.

    search: 'חיפוש לקוח, ריטיינר, עבודה או קובץ',

    // The archive is a separate view — an archived מסמך is out of sight by definition,
    // so it is never mixed into the live list.
    showArchive: 'הצגת הארכיון',
    showLive: 'חזרה למסמכים הפעילים',

    // Fold headers. A closed fold still states how much is inside it.
    documentCount: (n) => (n === 1 ? 'מסמך אחד' : `${n} מסמכים`),
    retainersHeading: 'ריטיינרים',
    standaloneHeading: 'עבודות ללא ריטיינר',
    topicsHeading: 'עבודות בריטיינר',
    // The retainer's own paperwork, above its topics'. A job needs no counterpart
    // heading: its fold holds one list and the fold's title already names it.
    directDocuments: 'מסמכי הריטיינר',
    // The way OUT of this screen. Every fold links to the record it stands for, because
    // the one action this page cannot offer is the one you will want the moment you see
    // a document is missing — and that action lives on the record's own screen.
    openClient: 'פתיחת כרטיס הלקוח',

    // Table columns.
    name: 'מסמך',
    kind: 'סוג',
    belongsTo: 'שייך ל',
    date: 'תאריך המסמך',
    uploadedBy: 'הועלה על ידי',
    archivedBy: 'הועבר לארכיון על ידי',

    // What each row IS. The kind decides which existing endpoint opens the file, so it
    // is worth naming on the row as well — four different documents in one list are
    // unreadable without it.
    kinds: {
      retainer_agreement: 'הסכם ריטיינר',
      job_agreement: 'הסכם עבודה',
      invoice_file: 'סריקת חשבונית',
      publication_file: 'גזיר פרסום',
    },

    // The context line under a row: what the file hangs off, when that is not already
    // the fold you are looking at. An agreement needs none — it belongs to the fold
    // itself — so only these two have one.
    invoicePeriod: (month) => `חשבונית לחודש ${month}`,
    invoiceNoPeriod: 'חשבונית',
    clipping: (publication, outlet) => `${publication} · ${outlet}`,

    empty: 'אין מסמכים של לקוחות.',
    emptyArchive: 'אין מסמכים בארכיון.',
    emptySearch: 'אין מסמך שתואם את החיפוש.',
    // A fold that is on screen only as the path to something below it.
    emptyNode: 'אין מסמכים ברמה הזו.',
  },
};

export default clientDocuments;
